<template>
  <div
    id="notificacao-modal"
    v-if="notificacaoSelecionada != null"
    :class="modalClass"
    :key="ultimaAtualizacao"
  >
    <transition name="modal">
      <div id="modal-global-notificacao" :class="notificacaoSelecionada.classe">
        <div class="modal-mask">
          <div class="modal-wrapper">
            <div class="modal-dialog">
              <div class="modal-content">
                <div class="modal-header">
                  <h3 class="modal-title">
                    <img
                      v-if="notificacaoSelecionada.icon != null"
                      :src="notificacaoSelecionada.icon"
                      :alt="notificacaoSelecionada.titulo"
                    />
                    {{ notificacaoSelecionada.titulo }}
                  </h3>

                  <button
                    type="button"
                    aria-label="Close"
                    class="close"
                    @click="visibilityModal(false)"
                  >
                    ×
                  </button>
                </div>
                <div class="modal-body text-center">
                  <p v-text="TextoCorpoNotificacao(notificacaoSelecionada)"></p>

                  <div class="text-center">
                    <b-button
                      id="modal-global-notificacao-ver-mais"
                      @click="handleNotificacaoRespostaRedirect"
                      >Ver mais</b-button
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { BModal, BButton } from "bootstrap-vue";
import auth from "@/router/routes/auth";
import erros from "@/router/routes/erros";
import minhaConta from "@/router/routes/minhaConta";

export default {
  components: {
    BModal,
    BButton,
  },
  data() {
    return {
      routesIgnore: [],
      lastRoute: null,
      showModal: true,
      modalClass: "",
      processed: [],
      modal: {
        itens: [],
      },
    };
  },
  beforeMount() {
    this.routesIgnore = [...auth, ...erros, ...minhaConta.slice(1)].map(
      (route) => route.name
    );
  },
  methods: {
    TextoCorpoNotificacao(notificacao) {
      let retorno = notificacao.conteudo;


      return retorno;
    },
    handleNotificacaoRespostaRedirect() {
      let redirect = {
        name: this.notificacaoSelecionada.route.name,
        params: {
          notificationUpdateUserNotificationAsRead: this.notificacaoSelecionada,
        },
      };

      this.$helpers.findIndexInArray(
        this.modal.itens,
        this.notificacaoSelecionada,
        "id_notificacao_usuario"
      );

      this.$router.push(redirect).catch((err) => {
        if (err.name !== "NavigationDuplicated") {
          throw err;
        }
      });
    },
    visibilityModal(show = false) {
      this.showModal = show;
      this.modalClass = !show ? "d-none" : "";
    },
  },
  computed: {
    ultimaAtualizacao() {
      return this.$store.getters["notifications/getUpdatedAt"];
    },
    notificacaoSelecionada() {
      let itensFiltereds = [];
      if (this.modal.itens.length > 0) {
        this.modal.itens.forEach((item) => {
          let index = this.$helpers.findIndexInArray(
            this.processed,
            item,
            "id_notificacao_usuario"
          );

          if (index === -1) {
            itensFiltereds.push(item);
          }
        });

        let itens = itensFiltereds.sort((a, b) => a.prioridade - b.prioridade),
          icon = null;

        if (itens.length > 0) {
          let selecionada = itens[0];

          return {
            ...{ icon },
            ...{ classe },
            ...selecionada,
          };
        }
      }
      return null;
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/custom/notificacao-modal.scss";
</style>
